export default "https://cdn-static.gokick.com/assets/c0e4f86ff5da21e4b09546702d214e718bb56dad/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";